import { useContext, useMemo } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';
import { useIsMobile } from '@/hooks/useIsMobile';
import { DrawerScreen } from '@/types/screens';

export const useTemplateFeatures = () => {
  const {
    viewer: { screen },
    template,
  } = useContext(CheckoutContext);

  const isMobile = useIsMobile();

  const shouldShowExpressCheckout = useMemo(
    () => template.features.showExpressCheckout && screen !== DrawerScreen.SAVED_CARDS,
    [template.features.showExpressCheckout, screen]
  );

  const shouldShowPaymentMethods = useMemo(
    () => template.features.showPaymentMethods && screen !== DrawerScreen.SAVED_CARDS,
    [template.features.showPaymentMethods, screen]
  );

  const shouldShowDesktopViewer = useMemo(
    () => !isMobile && template.features.showDesktopViewer,
    [isMobile, template.features.showDesktopViewer]
  );

  const shouldShowPaymentMethodForm = useMemo(() => {
    if (screen && !isMobile) {
      return false;
    }
    return template.features.autoSelectPaymentMethod || isMobile || !screen;
  }, [template.features.autoSelectPaymentMethod, isMobile, screen]);

  const centerContentOnDesktop = useMemo(
    () => template.features.centerContentOnDesktop,
    [template.features.centerContentOnDesktop]
  );

  return {
    isMobile,
    shouldShowExpressCheckout,
    shouldShowPaymentMethods,
    shouldShowDesktopViewer,
    shouldShowPaymentMethodForm,
    centerContentOnDesktop,
  };
};
